import { Injectable } from '@angular/core';
import { IBrowser, IDevice, IOS, IResult, UAParser } from 'ua-parser-js';

import { StoreService } from '@ecm/dispatcher';

@Injectable({
    providedIn: 'root',
})
export class UaService {
    /**
     * UAParser result (Singleton)
     */
    private ua: IResult;

    public getOSName(): string {
        return this.getOS().name;
    }

    public getOSVersion(): string {
        return this.getOS().version;
    }

    public getBrowserName(): string {
        return this.getBrowser().name;
    }

    public getBrowserVersion(): string {
        return this.getBrowser().version;
    }

    public getDeviceType(): string {
        return this.getDevice().type ? this.getDevice().type : 'desktop';
    }

    public isMobile(): boolean {
        return this.getDevice().type === 'mobile';
    }

    public isTablet(): boolean {
        return this.getDevice().type === 'tablet';
    }

    private getOS(): IOS {
        return this.getUA().os;
    }

    private getBrowser(): IBrowser {
        return this.getUA().browser;
    }

    private getDevice(): IDevice {
        return this.getUA().device;
    }

    /**
     * Store User Agent data in StoreService
     * @deprecated Features should directly use public methods from this service, and not StoreService
     * Based on UAParser result
     */
    private storeUserAgent(): void {
        const ua = {
            os: {
                name: this.getOS().name,
                version: this.getOS().version,
            },
            browser: {
                name: this.getBrowser().name,
                version: this.getBrowser().version,
            },
            device: {
                model: this.getDevice().model,
                type: this.getDevice().type,
                vendor: this.getDevice().vendor,
            },
            isMobile: this.getDevice().type === 'mobile',
        };
        StoreService.set('ua', ua);
    }

    /**
     * UAParser Singleton getter
     * @returns {IResult}
     */
    private getUA(): IResult {
        if (!this.ua) {
            this.ua = new UAParser().getResult();
            // eslint-disable-next-line deprecation/deprecation -- storage is deprecated, but still used by FT
            this.storeUserAgent();
        }
        return this.ua;
    }
}
